import React, { useState } from "react";
import { Flag, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useConfirm } from "../context/ConfirmContext";
import { ukDate } from "../lib/dates";

export const CourseFinishToggle = ({ course, onChange }) => {
  const { user } = useAuth();
  const confirm = useConfirm();
  const [busy, setBusy] = useState(false);
  const caps = user?.caps || {};
  const canToggle = user?.role === "admin" || user?.role === "pastor" || caps.is_admin || caps.is_pastor;
  const finished = !!course.finished;
  const toggle = async () => {
    const ok = await confirm({
      title: finished ? "Reopen this course?" : "Mark this course as finished?",
      description: finished
        ? "Reminders and alerts will start again and learners will be able to submit work."
        : "All reminders and alerts for this course will stop, and learners can view but no longer submit work.",
      confirmLabel: finished ? "Reopen course" : "Mark finished",
      tone: "default",
    });
    if (!ok) return;
    setBusy(true);
    try {
      await api.post(`/courses/${course.id}/finish`, { finished: !finished });
      toast.success(finished ? "Course reopened" : "Course marked as finished — reminders stopped");
      onChange();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="course-finish-area">
      {finished && (
        <span data-testid="course-finished-badge" className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1 rounded-full" style={{ background: "#EDF0FF", color: "#3B5BDB" }}>
          <Flag className="h-3.5 w-3.5" /> Finished{course.finished_at ? ` ${ukDate(course.finished_at)}` : ""} · reminders off
        </span>
      )}
      {canToggle && (
        <button data-testid="course-finish-toggle" disabled={busy} onClick={toggle}
          className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold border disabled:opacity-50 hover:brightness-95"
          style={finished ? { borderColor: "var(--sj-primary)", color: "var(--sj-primary)", background: "#fff" } : { borderColor: "#3B5BDB", color: "#3B5BDB", background: "#fff" }}>
          {finished ? <><RotateCcw className="h-4 w-4" /> Reopen course</> : <><Flag className="h-4 w-4" /> Mark as finished</>}
        </button>
      )}
    </div>
  );
};
